import { usePreQuestions } from "@/components/features/items/edit/_shared/ui/components/main/questions/pre-question/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../../context";

export const usePlanPreQuestions = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { questions } = viewModel;

	return {
		...usePreQuestions({ questions, onSetViewModel }),
	};
};
